export { default } from './ManualPageTable';
